import { isNil } from 'lodash';
import {
  IChartSettings,
  IParsedChartDataFunnel,
  IParsedFunnelColumn,
} from '../../../interfaces';
import { filterVisibleColumnsBySlice, IChartLine } from '../../useChartLines';
import { getSelectedFunnelModeSlice } from './utils';
import {
  getMeasureColorFromColorConfig,
  getSliceColorFromColorConfig,
  IAnalysisColorConfig,
} from '../../../utils/analysisColorConfig';
import { isLastStepInFreqOrTTCWhichSkipMiddleSteps } from '../../../FunnelChart/utils';

const getTimeToConvertLines = (
  sortedColumns: IParsedFunnelColumn[],
  chartData: IParsedChartDataFunnel,
  chartSettings: IChartSettings,
  colorConfig: IAnalysisColorConfig,
  shouldUseMeasureColor: boolean,
): IChartLine[] => {
  const { funnelModeSlice } = getSelectedFunnelModeSlice(
    chartData,
    chartSettings,
  );

  if (isNil(funnelModeSlice)) {
    return [];
  }

  const visibleColumnsBySlice = filterVisibleColumnsBySlice(
    sortedColumns,
    chartSettings,
  );

  const selectedFunnelModeSliceKey = funnelModeSlice.key;

  const visibleColumnsBySliceAndFunnelMode = visibleColumnsBySlice.filter(
    (c) => c.funnelModeSliceKey === selectedFunnelModeSliceKey,
  );

  // to identify the last step in time to convert that needed to be colored differently
  // we need to check if the measure selection has all true values and the length >= 3
  const isTimeToConvertLastStep = isLastStepInFreqOrTTCWhichSkipMiddleSteps(
    funnelModeSlice.measureSelection,
  );

  const measureColorKey = isTimeToConvertLastStep
    ? funnelModeSlice.lastMeasureKey
    : funnelModeSlice.firstMeasureKey;

  return visibleColumnsBySliceAndFunnelMode.map((column) => {
    const color = shouldUseMeasureColor
      ? getMeasureColorFromColorConfig(colorConfig, measureColorKey)
      : getSliceColorFromColorConfig(colorConfig, column.sliceKey);

    return {
      name: column.key,
      display: column.name,
      color,
      type: 'normal',
      measureKey: column.measureKey,
    };
  });
};

export default getTimeToConvertLines;
